import { useState } from 'react';
import styles from './styles.module.css'
import { Button, Grid, styled, TextField } from '@mui/material';
import UploadFileIcon from "@mui/icons-material/UploadFile";

const Documentos = ({ handleStep,
  dataForm,
  setMsg,
  setOpenSnackbarErro,
  error,
  setError,
  files,
  setFiles
}) => {

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleFileChange = (e) => {
    const { files: file, name: key } = e.target;
    setFiles((prevFiles) => ({ ...prevFiles, [key]: file[0] }));
  };

  const requiredFiles = dataForm.responsavelEmpresa.estrangeiro === 'true' 
  ? [
    'rg', 
    'cpf', 
    'comprovante_residencia',
    'rne',
    'passaporte', 
    'cpf_socios', 
    'comprovante_residencia_socios', 
    'comprovante_residencia_empresa', 
    'contrato_social', 
    'cartao_cnpj'
  ]
  :[
    'rg', 
    'cpf', 
    'comprovante_residencia', 
    'cpf_socios', 
    'comprovante_residencia_socios', 
    'comprovante_residencia_empresa', 
    'contrato_social', 
    'cartao_cnpj'
  ];

  const handleRequiredFiles = () => {
    return requiredFiles.every((fileKey) => fileKey in files);
  };

  const handleNext = (e) => {
    e.preventDefault()
    if (!handleRequiredFiles()) {
      setMsg('Ainda existem anexos obrigatórios que não foram enviados!')
      setOpenSnackbarErro(true)
      setError(true)
      return;
    }
      handleStep(7)
 
  }

  const handleBack = () => {
    handleStep(5)
  }

  return (
    <form onSubmit={handleNext}>
      <Grid container spacing={2} sx={{marginBottom: '1rem'}}>
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="RG"
              fullWidth
              className={(error && !("rg" in files)) && styles.textFieldAnexoFaltando}
              value={"rg" in files ? files["rg"].name : ""}
              error={(error && !("rg" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadRg"
              onChange={handleFileChange}
              className={
                "rg" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"rg" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="rg" />
            </Button>
          </div>
        </Grid>

        {/* CPF */}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="CPF"
              fullWidth
              className={(error && !("cpf" in files)) && styles.textFieldAnexoFaltando}
              value={"cpf" in files ? files["cpf"].name : ""}
              error={(error && !("cpf" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadCpf"
              onChange={handleFileChange}
              className={
                "cpf" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"cpf" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="cpf" />
            </Button>
          </div>
        </Grid>

        {/*Comprovante de Residência*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="Comprovante de Residência"
              fullWidth
              className={(error && !("comprovante_residencia" in files)) && styles.textFieldAnexoFaltando}
              value={
                "comprovante_residencia" in files
                  ? files["comprovante_residencia"].name
                  : ""
              }
              error={(error && !("comprovante_residencia" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadComprovante"
              onChange={handleFileChange}
              className={
                "comprovante_residencia" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"comprovante_residencia" in files ? (
                "Ok"
              ) : (
                <UploadFileIcon />
              )}
              <VisuallyHiddenInput
                type="file"
                name="comprovante_residencia"
              />
            </Button>
          </div>
        </Grid>

        {/*Passaporte*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="Passaporte"
              className={(dataForm.responsavelEmpresa.estrangeiro === 'true' && error && !("passaporte" in files)) && styles.textFieldAnexoFaltando}
              fullWidth
              value={
                "passaporte" in files ? files["passaporte"].name : ""
              }
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadPassaporte"
              onChange={handleFileChange}
              className={
                "passaporte" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"passaporte" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="passaporte" />
            </Button>
          </div>
        </Grid>

        {/*RNE*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="RNE"
              fullWidth
              className={(dataForm.responsavelEmpresa.estrangeiro === 'true' && error && !("rne" in files)) && styles.textFieldAnexoFaltando}
              value={"rne" in files ? files["rne"].name : ""}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadRne"
              onChange={handleFileChange}
              className={
                "rne" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"rne" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="rne" />
            </Button>
          </div>
        </Grid>

        {/*CPF dos socios*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="CPF dos sócios"
              className={(error && !("cpf_socios" in files)) && styles.textFieldAnexoFaltando}
              fullWidth
              value={
                "cpf_socios" in files ? files["cpf_socios"].name : ""
              }
              error={(error && !("cpf_socios" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadCpfSocios"
              onChange={handleFileChange}
              className={
                "cpf_socios" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"cpf_socios" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="cpf_socios" />
            </Button>
          </div>
        </Grid>

        {/*Comprovante de Residência dos socios */}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="Comprovante de  Residência dos Sócios"
              fullWidth
              className={(error && !("comprovante_residencia_socios" in files)) && styles.textFieldAnexoFaltando}
              value={
                "comprovante_residencia_socios" in files
                  ? files["comprovante_residencia_socios"].name
                  : ""
              }
              error={(error && !("comprovante_residencia_socios" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadComprovanteSocios"
              onChange={handleFileChange}
              className={
                "comprovante_residencia_socios" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"comprovante_residencia_socios" in files ? (
                "Ok"
              ) : (
                <UploadFileIcon />
              )}
              <VisuallyHiddenInput
                type="file"
                name="comprovante_residencia_socios"
              />
            </Button>
          </div>
        </Grid>

        {/*Comprovante de Residência da empresa*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="Comprovante de Residência da Empresa"
              className={(error && !("comprovante_residencia_empresa" in files)) && styles.textFieldAnexoFaltando}
              fullWidth
              value={
                "comprovante_residencia_empresa" in files
                  ? files["comprovante_residencia_empresa"].name
                  : ""
              }
              error={(error && !("comprovante_residencia_empresa" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadComprovanteEmpresa"
              onChange={handleFileChange}
              className={
                "comprovante_residencia_empresa" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"comprovante_residencia_empresa" in files ? (
                "Ok"
              ) : (
                <UploadFileIcon />
              )}
              <VisuallyHiddenInput
                type="file"
                name="comprovante_residencia_empresa"
              />
            </Button>
          </div>
        </Grid>
        {/*Contrato Social*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="Contrato Social"
              className={(error && !("contrato_social" in files)) && styles.textFieldAnexoFaltando}
              fullWidth
              value={
                "contrato_social" in files
                  ? files["contrato_social"].name
                  : ""
              }
              error={(error && !("contrato_social" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadContratoSocial"
              onChange={handleFileChange}
              className={
                "contrato_social" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"contrato_social" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput
                type="file"
                name="contrato_social"
              />
            </Button>
          </div>
        </Grid>
        {/*Cartão CNPJ*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="Cartão CNPJ"
              className={(error && !("cartao_cnpj" in files)) && styles.textFieldAnexoFaltando}
              fullWidth
              value={
                "cartao_cnpj" in files
                  ? files["cartao_cnpj"].name
                  : ""
              }
              error={(error && !("cartao_cnpj" in files))}
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadCartaoCnpj"
              onChange={handleFileChange}
              className={
                "cartao_cnpj" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"cartao_cnpj" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="cartao_cnpj" />
            </Button>
          </div>
        </Grid>
        {/*CRC*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="CRC"
              fullWidth
              value={
                "crc" in files
                  ? files["crc"].name
                  : ""
              }
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadCRC"
              onChange={handleFileChange}
              className={
                "crc" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"crc" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="crc" />
            </Button>
          </div>
        </Grid>
        {/*OAB*/}
        <Grid item xs={12} sm={6}>
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
              }}
              size="small"
              label="OAB"
              fullWidth
              value={
                "oab" in files
                  ? files["oab"].name
                  : ""
              }
              InputProps={{ endAdornment: null }}
              disabled
            />

            <Button
              component="label"
              variant="contained"
              size="small"
              id="btnUploadOAB"
              onChange={handleFileChange}
              className={
                "oab" in files
                  ? styles.botaoUploadOk
                  : styles.botaoUpload
              }
            >
              {"oab" in files ? "Ok" : <UploadFileIcon />}
              <VisuallyHiddenInput type="file" name="oab" />
            </Button>
          </div>
        </Grid>
      </Grid>
      <div className={styles.container_button}>
        <Button
          className={styles.button_back}
          onClick={handleBack}
        >
          Voltar
        </Button>
        <Button
          className={styles.button_next}
          type='submit'
        >
          Avançar
        </Button>
      </div>
    </form>
  )
}

export default Documentos